import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { DatePicker, message, Row, Select, Tag, Tooltip } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

// components
import DownloadPopUp from '../../reports/reportsTimeSheet/downloadPopUp'

import dayjs from 'dayjs'
import { getAllUserReportList, setDrawerFilter, setTableData } from '../store/finalReports.slice'
import { timesheetApi } from '../../reports/reportsTimeSheet/redux/apis'
import { reportsActions } from '../../reports/reportsTimeSheet/redux/slice'

const { RangePicker } = DatePicker
const { Option } = Select

const DateFilter = ({ props }) => {
    const dispatch = useDispatch()
    const { tableData, totalLog } = useSelector((state) => state.finalReportsSlice)

    const { selectAssignees, selectedProject, name, filteredProjects, setShowWorkReport } = props

    const disableFutureDates = (current) =>
        current && current > dayjs().endOf('day')

    const handleDateTypeChange = (type) => {
        const today = dayjs()
        let start = null,
            end = null

        switch (type) {
            case 'day':
                start = today.startOf('day').valueOf()
                end = today.endOf('day').valueOf()
                break
            case 'week':
                start = today.startOf('week').startOf('day').valueOf()
                end = today.endOf('week').endOf('day').valueOf()
                break
            case 'month':
                start = today.startOf('month').startOf('day').valueOf()
                end = today.endOf('month').endOf('day').valueOf()
                break
            default:
                start = null
                end = null
        }

        const dataSet = {
            ...tableData,
            page: 1,
            start,
            end,
        }

        dispatch(
            setTableData({
                ...dataSet,
                dateType: type,
            })
        )
        dispatch(
            setDrawerFilter({
                ...dataSet,
                dateType: type,
            })
        )

        // dispatch(
        //     getAllUserReportList({
        //         ...dataSet,
        //     })
        // )
    }

    const handleDateChange = (val) => {
        if (!val) return

        let start = null,
            end = null

        if (tableData.dateType === 'custom') {
            start = val[0].startOf('day').valueOf()
            end = val[1].endOf('day').valueOf()
        } else {
            const date = dayjs(val)
            if (tableData.dateType === 'day') {
                start = date.startOf('day').valueOf()
                end = date.endOf('day').valueOf()
            } else if (tableData.dateType === 'week') {
                start = date.startOf('week').startOf('day').valueOf()
                end = date.endOf('week').endOf('day').valueOf()
            } else if (tableData.dateType === 'month') {
                start = date.startOf('month').startOf('day').valueOf()
                end = date.endOf('month').endOf('day').valueOf()
            }
        }

        const dataSet = {
            ...tableData,
            page: 1,
            start,
            end,
        }

        dispatch(
            setTableData({
                ...dataSet,
            })
        )

        dispatch(
            setDrawerFilter({
                ...dataSet,
            })
        )
        // dispatch(
        //     getAllUserReportList({
        //         ...dataSet,
        //     })
        // )
    }

    // useEffect(() => {
    //     // set initial value when component mounts
    //     handleDateTypeChange(tableData.dateType || 'day')
    // }, [])


    const onFinish = async () => {
        dispatch(reportsActions.setLoading(true))

        const selectedProjectData = filteredProjects.find(
            (p) => p.value === selectedProject.value
        )
        const assigneesId = selectAssignees.map((a) => a.value)
        const start = tableData.start
        const end = tableData.end

        const reqData = {
            projectId: selectedProject.value,
            start,
            end,
            assigneeId: assigneesId,
        }
        // setSubmitting(true)
        const reportRes = await timesheetApi(reqData)

        if (reportRes?.data?.success) {
            // setIsEditReport(true)
            dispatch(reportsActions.setLoading(false))
            dispatch(
                reportsActions.downloadPdfData({
                    pdfData: reportRes.data,
                    pdfSelectedData: {
                        assignees: selectAssignees,
                        start,
                        end,
                        project: {
                            id: selectedProject.value,
                            name: selectedProjectData?.label,
                        },
                    },
                })
            )
        } else {
            message.error(reportRes?.data?.message)
            // setIsEditReport(false)
        }
        // setSubmitting(false)
    }

    const formatTimeFromMilliseconds = (ms) => {
        if (!ms || isNaN(ms)) return '0'

        const totalSeconds = Math.floor(ms / 1000)
        const totalMinutes = Math.floor(totalSeconds / 60)
        const totalHours = Math.floor(totalMinutes / 60)
        const minutes = totalMinutes % 60
        const seconds = totalSeconds % 60

        let result = ''
        if (totalHours > 0) result += `${totalHours}h `
        if (minutes > 0) result += `${minutes}m `
        if (seconds > 0 || result === '') result += `${seconds}s`

        return result.trim()
    }

    return (
        <>
            {name === 'timeSheet' && (
                <DownloadPopUp
                    previewModal={props.downloadModal}
                    onCancel={() => props.setIsEditReport(false)}
                    modalTitle="Download Reports"
                    selectAssignees={selectAssignees}
                    selectedProject={selectedProject}
                />
            )}

            <Row
                align="middle"
                justify="end"
                style={{ columnGap: '20px', width: '100%', flexWrap: 'nowrap' }}
            >
                <Tag color="blue" style={{ padding: "14px", fontWeight: "700", marginRight: "0px" }}>Total Log: {formatTimeFromMilliseconds(totalLog)}</Tag>
                <div className="reportsDate">
                    {tableData.dateType === 'custom' ? (
                        <RangePicker
                            onChange={handleDateChange}
                            allowClear={false}
                            format="DD/MM/YYYY"
                            disabledDate={disableFutureDates}
                            value={[
                                tableData.start ? dayjs(tableData.start) : null,
                                tableData.end ? dayjs(tableData.end) : null,
                            ]}
                            inputReadOnly
                        />
                    ) : (
                        <DatePicker
                            picker={tableData.dateType}
                            allowClear={false}
                            value={[
                                tableData.start ? dayjs(tableData.start) : null,
                                tableData.end ? dayjs(tableData.end) : null,
                            ]}
                            onChange={handleDateChange}
                            format={
                                tableData.dateType === 'day'
                                    ? 'DD/MM/YYYY'
                                    : tableData.dateType === 'week'
                                        ? 'DD/MM'
                                        : 'MM/YYYY'
                            }
                            disabledDate={disableFutureDates}
                            inputReadOnly
                        />
                    )}
                </div>

                <Select
                    placeholder="Filter"
                    value={tableData.dateType}
                    onChange={handleDateTypeChange}
                    style={{ width: 120 }}
                >
                    <Option value="day">Day</Option>
                    <Option value="week">Week</Option>
                    <Option value="month">Month</Option>
                    <Option value="custom">Custom</Option>
                </Select>

                {name === 'timeSheet' && (
                    <Tooltip title="Export as PDF">
                        <DownloadOutlined
                            onClick={() => { props.setIsEditReport(true); onFinish(); setShowWorkReport(true); }}
                            style={{ cursor: 'pointer', marginLeft: '10px' }}
                        />
                    </Tooltip>
                )}
            </Row>
        </>
    )
}

export default DateFilter
